module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PreventionDetailView.js"));
	}, "PreventionDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PreventionDetailView!./src/pages/Promote/OfflineActivity/PreventionDetail/PreventionDetailView.js
// module id = 1680
// module chunks = 418